import {Injectable} from '@angular/core';
import {ApiService} from '../../app-common/services/server/api.service';
import {LoggerService} from '../../logging/services/logger.service';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSourceType} from '../../logging/data/logSourceType';
import {LogSource} from '../../logging/data/logSource';
import {AccountSettings} from '../data/AccountSettings';

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsService {

  constructor(public httpService: ApiService,
              public loggingService: LoggerService) {
  }

  async getSettings(): Promise<AccountSettings> {
    // if (settingsId === null) {
    //   return undefined;
    //   this.loggingService.logMessage(LogLevel.ERROR, LogSourceType.SERVICE, LogSource.AccountSettingsService, 'Failed to fetch account settings!');
    //   // this.loggingService.logMessage(LogLevel.DEBUG, LogSourceType.SERVICE, LogSource.SnippetService, 'Failed to fetch snippets!');
    // }
    try {
      return await this.httpService.applicationApiClient.get<AccountSettings>(`AccountSettings/GetAccountSettings`);
    } catch (e) {
      this.loggingService.logMessage(LogLevel.ERROR, LogSourceType.SERVICE, LogSource.AccountSettingsService, 'Failed to fetch account settings!' + e);
    }
  }

  async saveSettings(request: AccountSettings): Promise<AccountSettings> {
    try {
      return await this.httpService.applicationApiClient.put<AccountSettings>(`AccountSettings`, request.id, request);
    } catch (e) {
      this.loggingService.logMessage(LogLevel.ERROR, LogSourceType.SERVICE, LogSource.AccountSettingsService, 'Failed to update account settings!' + e);
    }
  }
}
